// extracted by mini-css-extract-plugin
export default {"wrapper":"ACkrfScoj8Z2fQBMz_IF"};